export enum TypeEntity {
	costs = "costs",
	fee = "fee",
}
